import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Thankyou = () => {
  return (
    <Box
      gap="s24"
      padding="s24"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
    >
      <Box
        padding="s12"
        alignSelf="center"
        background="grey200"
        borderRadius={{
          all: 'abs008',
        }}
      >
        <Icon.Large icon={'task'} color="viridian1200" />
      </Box>
      <Box gap={'s12'} textAlign="center">
        <Text size="400" weight="medium" color="grey800">
          {i18n.t('pricing_plans.help_info.callpage_modal.ty_title')}
        </Text>
        <Text.Normal>{i18n.t('pricing_plans.help_info.callpage_modal.ty_description')}</Text.Normal>
      </Box>
    </Box>
  )
}

export default Thankyou
